/**
 * Validation module.
 * Exports public validation API.
 *
 * @copyright Realeyes OU. All rights reserved.
 */

import ValidationManager from './ValidationManager';
import ValidationResult from './ValidationResult';
import FacePositionValidator from './FacePositionValidator';
import VideoActivityValidator from './VideoActivityValidator';


export default {
    ValidationManager,
    ValidationResult,
    validators: {
        FacePositionValidator,
        VideoActivityValidator,
    },
};
